import React, { useState } from 'react';
import Navbar from '../../Navbar/Navbar';
import './Aboutus.css';
import { Link } from 'react-router-dom';
import principalHead from '../../Images/principalhead.jpeg';
import principal from '../../Images/principal.jpeg';
import vicePrincipal from '../../Images/viceprincipal.jpeg';


const stats = [
  { value: '25+', label: 'Years of Excellence' },
  { value: '5000+', label: 'Students Enrolled' },
  { value: '30+', label: 'Qualified Faculty' },
  { value: '50+', label: 'Awards & Accolades' },
];

const values = [
  {
    icon: '🕊️',
    title: 'Spiritual Values',
    desc: 'Rooted in the teachings of spiritual values, we nurture the spiritual growth of every student alongside academic excellence.',
  },
  {
    icon: '🔬',
    title: 'Modern Education',
    desc: 'We embrace cutting-edge educational technologies and methodologies to prepare students for the challenges of the 21st century.',
  },
  {
    icon: '🌱',
    title: 'Holistic Development',
    desc: 'Physical, mental, intellectual, and aesthetic growth — we cultivate every dimension of a child\'s personality.',
  },
  {
    icon: '🤝',
    title: 'Community & Culture',
    desc: 'We preserve the Prachin sikhya parampara while fostering a vibrant, inclusive community of learners and educators.',
  },
];

const leadership = [
   {
    name: 'Mr. Kaliprasanna Mohanty',
    role: 'Principal',
    img: principalHead,  
    quote: 'Education is the most powerful tool to change the world.',
  },
  {
    name: 'Mr.Debabrata Das',
    role: 'Vice Principal',
    img: principal,  
    quote: 'Education is the process of gaining knowledge, skills, values and attitudes through learning and teaching. It can happen in schools, at home, in the community or through self-study and it helps people develop their thinking and prepare for life.',
  },
  {
    name: 'Mr Dillip kumar Sarangi',
    role: 'Senior Faculty',
    img: vicePrincipal,  
    quote: 'With experienced and dedicated teachers and excellent infrastructure, our school helps students to realize their goals in life. I encourage all students to take advantage of the opportunities provided by the school. The overall development of the mind and body is a sign of a healthy and complete development. Hard work, dedication and perseverance are the most important traits in a person that lead to success. The future belongs to you; your need, therefore, is to prepare yourself for an active participation in the world. This participation demands that you become well informed and hence develop yourself like a pioneer and ultimately grow as responsible men and women.Dillip Sarangi',
  },
];

const milestones = [
  { year: '2000', title: 'Foundation', desc: 'Little flowers school, Odisha was established in 2000.' },
  { year: '2005', title: 'Infrastructure Expansion', desc: 'State-of-the-art science labs, library, and sports complex inaugurated.' },
  { year: '2015', title: 'Digital Classrooms', desc: 'Fully equipped smart classrooms integrated across all grades.' },
  { year: '2020', title: 'Online Learning', desc: 'Seamlessly transitioned to hybrid learning during the global pandemic.' },
  { year: '2025', title: 'CBSE Affiliation', desc: 'Received CBSE affiliation, opening doors to national academic standards.' },
  { year: '2026', title: '26 Years of Excellence', desc: 'Celebrated silver jubilee with 5000+ alumni across India and abroad.' },
];

const AboutPage = () => {
  const [activeTab, setActiveTab] = useState('vision');

  return (
    <div className="about-page">
     
       <Navbar />
      {/* ===== HERO ===== */}
      <section className="ab-hero">
        <div className="ab-hero__overlay" />
        <div className="ab-hero__content">
          <span className="ab-hero__eyebrow">About Little flowers School</span>
          <h1 className="ab-hero__title">
            Where Ancient Wisdom Meets<br />Modern Excellence
          </h1>
          <p className="ab-hero__sub">
            Managed by Kaliprasanna Mohanty · CBSE Affiliated · Est. 2000 · Odisha
          </p>
          <div className="ab-hero__pills">
            <span className="pill">Affiliated to CBSE</span>
            <span className="pill">Rairangpur, Odisha</span>
            <span className="pill">Aff. No. 153047</span>
          </div>
        </div>
        <div className="ab-hero__stats">
          {stats.map((s) => (
            <div className="stat-card" key={s.label}>
              <span className="stat-value">{s.value}</span>
              <span className="stat-label">{s.label}</span>
            </div>
          ))}
        </div>
      </section>

      {/* ===== VISION / MISSION TABS ===== */}
      <section className="ab-tabs-section">
        <div className="ab-tabs-section__inner">
          <div className="tab-buttons">
            {['vision', 'mission', 'philosophy'].map((t) => (
              <button
                key={t}
                className={`tab-btn ${activeTab === t ? 'tab-btn--active' : ''}`}
                onClick={() => setActiveTab(t)}
              >
                {t.charAt(0).toUpperCase() + t.slice(1)}
              </button>
            ))}
          </div>

          <div className="tab-content">
            {activeTab === 'vision' && (
              <div className="tab-pane">
                <div className="tab-pane__text">
                  <h2>Our Vision</h2>
                  <p>
                   To be a beacon of holistic education at Little Flowers School, where we nurture young minds by blending India’s timeless cultural and spiritual values with world-class academics — empowering every child to bloom to their fullest potential.
                  </p>
                  <p>
                    We nurture a community at Little Flowers School where compassion, creativity, and critical thinking flourish together — helping every child bloom into a graduate who serves society with heart and mind.
                  </p>
                </div>
                <div className="tab-pane__visual vision-visual">
                  <div className="visual-ring">
                    <span>Vision</span>
                  </div>
                </div>
              </div>
            )}
            {activeTab === 'mission' && (
              <div className="tab-pane">
                <div className="tab-pane__text">
                  <h2>Our Mission</h2>
                  <p>
                    To provide a rich, inclusive, and value-based learning environment at Little Flowers School where every child blooms fearlessly in all facets — physical, mental, intellectual, and aesthetic.
                  </p>
                  <p>
                    We at Little Flowers School are committed to harnessing modern technology and innovative teaching methods to meet the needs, hopes, and dreams of every 21st-century child, helping them bloom in a digital world.
                  </p>
                </div>
                <div className="tab-pane__visual mission-visual">
                  <div className="visual-ring">
                    <span>Mission</span>
                  </div>
                </div>
              </div>
            )}
            {activeTab === 'philosophy' && (
              <div className="tab-pane">
                <div className="tab-pane__text">
                  <h2>Our Philosophy</h2>
                  <p>
                    Inspired by India's timeless <em>Guru-Shishya</em> tradition, Little Flowers School nurtures both education for life and education for living — blending character and competence so every flower blooms with wisdom and skill.
                  </p>
                  <p>
                    We foster creativity, character, and intelligence in each child while imparting a
                    culture of the heart through humane values — building not just scholars, but
                    compassionate human beings.
                  </p>
                </div>
                <div className="tab-pane__visual philosophy-visual">
                  <div className="visual-ring">
                    <span>Philosophy</span>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* ===== CORE VALUES ===== */}
      <section className="ab-values">
        <div className="ab-values__header">
          <span className="section-eyebrow">What Drives Us</span>
          <h2>Our Core Values</h2>
        </div>
        <div className="ab-values__grid">
          {values.map((v) => (
            <div className="value-card" key={v.title}>
              <span className="value-icon">{v.icon}</span>
              <h3>{v.title}</h3>
              <p>{v.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* ===== TIMELINE ===== */}
      <section className="ab-timeline">
        <div className="ab-timeline__header">
          <span className="section-eyebrow">Our Journey</span>
          <h2>Milestones Through the Years</h2>
        </div>
        <div className="timeline">
          {milestones.map((m, i) => (
            <div className={`timeline-item ${i % 2 === 0 ? 'left' : 'right'}`} key={m.year}>
              <div className="timeline-card">
                <span className="timeline-year">{m.year}</span>
                <h3>{m.title}</h3>
                <p>{m.desc}</p>
              </div>
              <div className="timeline-dot" />
            </div>
          ))}
          <div className="timeline-line" />
        </div>
      </section>

      {/* ===== LEADERSHIP ===== */}
      <section className="ab-leadership">
        <div className="ab-leadership__header">
          <span className="section-eyebrow">The People Behind Our Success</span>
          <h2>Our Leadership</h2>
        </div>
        <div className="leadership-grid">
          {leadership.map((l) => (
            <div className="leader-card" key={l.name}>
              <div className="leader-img">
                <img src={l.img} alt={l.name} />
              </div>
              <div className="leader-info">
                <blockquote>"{l.quote}"</blockquote>
                <strong>{l.name}</strong>
                <span>{l.role}</span>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* ===== AFFILIATION BANNER ===== */}
      <section className="ab-affiliation">
        <div className="ab-affiliation__content">
          <h2>Affiliated & Recognised</h2>
          <p>
            Little Flowers' School is affiliated to CBSE (Affiliation No.153047) and managed by
            Kaliprasanna Mohanty.
          </p>
          <div className="affil-badges">
            <div className="affil-badge">
              <span className="affil-badge__icon">🎓</span>
              <span>CBSE Affiliated</span>
            </div>
           
            
          </div>
        </div>
        <div className="ab-affiliation__cta">
          <a href="Admission" className="cta-btn cta-btn--white">Explore Admissions →</a>
         <Link to="/contact" className="adm-btn adm-btn--white"> contact us</Link>
        </div>
      </section>

      
    </div>
  );
};

export default AboutPage;